import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getTranslations } from '../../../services/languageUtils';
import { isMutual } from '../../../utils/isMutual';

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: {}
    };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  getDate(date) {
    date = new Date(date);
    return `${(date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)}/${(date.getDate() < 10 ? '0' + date.getDate() : date.getDate())}/${date.getFullYear()}`;
  }

  getHour(date) {
    date = new Date(date);
    return `${(date.getHours() < 10 ? '0' + date.getHours() : date.getHours())}:${(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())}`;
  }

  formatToBRL(number) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(number);
  }

  savePDF = () => {
    const { item } = this.props;
    const doc = new jsPDF();

    if(isMutual()){
      if(item.body?.paymentType !== "CREDIT") {
        doc.text('Comprovante de Pagamento', 14, 16);
        doc.autoTable({
          startY: 20,
          head: [["Field", "Value"]],
          body: Object.entries({
            "ID da transação": item.transactionId,
            "Valor": item.amount?.original ? `BRL ${item.amount.original}` : "N/A",
            "Data de criação": item.createAt,
            "Status": item.status,
            "ExternalId": item.clientRequestId,
            "Nome do Devedor": item.debtor?.name,
            "CNPJ do Devedor": item.debtor?.cnpj,
            "Tipo": item.type,
          }).map(([key, value]) => [key, value || "N/A"]),
        });
      }
      else {
        doc.text('Comprovante de Pagamento', 14, 16);
        doc.autoTable({
          startY: 20,
          head: [["Field", "Value"]],
          body: Object.entries({
            "Nome do Remetente": item.body.creditParty?.name,
            "Instituição Financeira": item.body.creditParty?.bank,
            "Chave Pix": item.body.creditParty?.key,
            "E-mail do Destinatário": item.body.debitParty?.email,
            "Valor": `BRL ${item.body.amount}`,
            "Status": item.status,
            "ID da Transação": item.body.endToEndId,
            "Tipo de Transação": item.body.transactionType,
            "Tipo de Pagamento": item.body.paymentType,
            "Tipo de Início": item.body.initiationType,
            "Urgência": item.body.urgency,
            "Observação": item.body.remittanceInformation,
          }).map(([key, value]) => [key, value || "N/A"]),
        });
      }
    }
    else {
      if(item.barCodeInfo) {
        doc.text("Comprovante de Pagamento", 14, 16);
        doc.autoTable({
          startY: 20,
          head: [["Field", "Value"]],
          body: Object.entries({
            "ID da transação": item.transactionId,
            "Valor": item.amount,
            "ID da requisição": item.clientRequestId,
            "Autenticação": item.authentication,
            "Covenant": item.convenant,
            "Data de criação": item.createDate,
            "Status": item.status,
            "Tipo de código de barras": item.barCodeInfo?.type,
            "Digitável": item.barCodeInfo?.digitable,
            "Bloco de autenticação 1": item.authenticationAPI?.Bloco1,
            "Bloco de autenticação 2": item.authenticationAPI?.Bloco2,
            "Autenticação Completa": item.authenticationAPI?.BlocoCompleto,
            "Comprovante": item.receipt?.receiptformatted,
          }).map(([key, value]) => [key, value || "N/A"]),
        });
      }
      else {
        doc.text('Comprovante de Pagamento', 14, 16);
        doc.autoTable({
          startY: 20,
          head: [['Descrição', 'Valor']],
          body: [
            ['ID', item.id],
            ['Status', 'CONFIRMADO'],
            ['Valor', this.formatToBRL(item.amount)],
            ['Código do cliente', item.clientCode],
            ['Identificador da transação', item.transactionIdentification],
            ['End To End ID', item.endToEndId],
            ['Tipo de iniciação', item.initiationType],
            ['Tipo de pagamento', item.paymentType],
            ['Urgência', item.urgency],
            ['Tipo de transação', item.transactionType],
            ['Conta (débito)', item.debitParty.account],
            ['Agência (débito)', item.debitParty.branch],
            ['Documento (débito)', item.debitParty.taxId],
            ['Nome (débito)', item.debitParty.name],
            ['Tipo de conta (débito)', item.debitParty.accountType],
            ['Banco (crédito)', item.creditParty.bank],
            ['Chave (crédito)', item.creditParty.key],
            ['Conta (crédito)', item.creditParty.account],
            ['Agência (crédito)', item.creditParty.branch],
            ['Documento (crédito)', item.creditParty.taxId],
            ['Nome (crédito)', item.creditParty.name],
            ['Tipo de conta (crédito)', item.creditParty.accountType],
            ['Mensagem', item.remittanceInformation],
          ],
        });
      }
    }
  
    doc.save('Comprovante de Pagamento.pdf');
  };

  render() {
    const { item, open, setOpen } = this.props;
    return (
      <span>
        {item && (
          <Transition.Root show={open} as={Fragment} style={{ zIndex: '200000' }} id="SliderOverComponent">
            <Dialog as="div" className="relative z-10" onClose={setOpen}>
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                  <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                    <Transition.Child
                      as={Fragment}
                      enter="transform transition ease-in-out duration-500 sm:duration-700"
                      enterFrom="translate-x-full"
                      enterTo="translate-x-0"
                      leave="transform transition ease-in-out duration-500 sm:duration-700"
                      leaveFrom="translate-x-0"
                      leaveTo="translate-x-full"
                    >
                      <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                        <Transition.Child
                          as={Fragment}
                          enter="ease-in-out duration-500"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in-out duration-500"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                            <button
                              type="button"
                              className="relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                              onClick={() => setOpen(false)}
                            >
                              <span className="absolute -inset-2.5" />
                              <span className="sr-only">{this.state.translations.closePanel}</span>
                              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </Transition.Child>
                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl slideOverComponent">
                          <div className="px-4 sm:px-6">
                            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                              <div className="spaceBetween">
                                <p>{this.state.translations.paymentResume}</p>
                              </div>
                            </Dialog.Title>
                          </div>
                          <div className="relative mt-6 flex-1 px-4 sm:px-6">
                          {
                              !this.props.item.barCodeInfo &&
                              !isMutual() &&
                              <span>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.id}</span>
                                  <b>{item.id}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.amount}</span>
                                  <b>{this.formatToBRL(item.amount)}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.clientCode}</span>
                                  <b>{item.clientCode}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.transactionIdentification}</span>
                                  <b>{item.transactionIdentification}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.endToEndId}</span>
                                  <b>{item.endToEndId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.initiationType}</span>
                                  <b>{item.initiationType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.paymentType}</span>
                                  <b>{item.paymentType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.urgency}</span>
                                  <b>{item.urgency}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.transactionType}</span>
                                  <b>{item.transactionType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.debitPartyAccount}</span>
                                  <b>{item.debitParty.account}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.debitPartyBranch}</span>
                                  <b>{item.debitParty.branch}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.debitPartyTaxId}</span>
                                  <b>{item.debitParty.taxId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.debitPartyName}</span>
                                  <b>{item.debitParty.name}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.debitPartyAccountType}</span>
                                  <b>{item.debitParty.accountType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyBank}</span>
                                  <b>{item.creditParty.bank}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyKey}</span>
                                  <b>{item.creditParty.key}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyAccount}</span>
                                  <b>{item.creditParty.account}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyBranch}</span>
                                  <b>{item.creditParty.branch}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyTaxId}</span>
                                  <b>{item.creditParty.taxId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyName}</span>
                                  <b>{item.creditParty.name}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.creditPartyAccountType}</span>
                                  <b>{item.creditParty.accountType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.status}</span>
                                  <b>{this.props.item.status}</b>
                                </div>
                              </span>
                            }
                            {
                              this.props.item.barCodeInfo &&
                              !isMutual() &&
                              <span>
                                <div className="spaceBetween border">
                                  <span>{this.state.translations.amount}</span>
                                  <b>{this.formatToBRL(item.amount)}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Digitável</span>
                                  <b>{this.props.item.barCodeInfo.digitable}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>{"ID de autorização"}</span>
                                  <b>{this.props.item.transactionIdAuthorize}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Autenticação</span>
                                  <b>{this.props.item.authentication}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Covenant</span>
                                  <b>{this.props.item.covenant}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Status</span>
                                  <b>{this.props.item.status}</b>
                                </div>
                              </span>
                            }
                            {
                              isMutual() &&
                              this.props.item.body?.paymentType !== "CREDIT" &&
                              <span>
                                <div className="spaceBetween border">
                                  <span>Debtor</span>
                                  <b>{this.props.item.debtor?.name}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>CNPJ</span>
                                  <b>{this.props.item.debtor?.cnpj}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Valor</span>
                                  <b>{this.formatToBRL(this.props.item.amount?.original)}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>ID da Transação</span>
                                  <b>{this.props.item.transactionId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Status</span>
                                  <b>{this.props.item.status}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Tipo</span>
                                  <b>{this.props.item.type}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>External ID</span>
                                  <b>{this.props.item.clientRequestId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Data de Criação</span>
                                  <b>{new Date(this.props.item.createAt).toLocaleString()}</b>
                                </div>
                              </span>
                            }
                            {
                              isMutual() &&
                              this.props.item.body?.paymentType === "CREDIT" &&
                              <span>
                                <div className="spaceBetween border">
                                  <span>Nome do Remetente</span>
                                  <b>{this.props.item.body.creditParty?.name}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Instituição Financeira</span>
                                  <b>{this.props.item.body.creditParty?.bank}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Chave Pix</span>
                                  <b>{this.props.item.body.creditParty?.key}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>E-mail do Destinatário</span>
                                  <b>{this.props.item.body.debitParty?.email}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Valor</span>
                                  <b>{this.formatToBRL(this.props.item.body.amount)}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Status</span>
                                  <b>{this.props.item.status}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>ID da Transação</span>
                                  <b>{this.props.item.body.endToEndId}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Tipo de Transação</span>
                                  <b>{this.props.item.body.transactionType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Tipo de Pagamento</span>
                                  <b>{this.props.item.body.paymentType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Tipo de Início</span>
                                  <b>{this.props.item.body.initiationType}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Urgência</span>
                                  <b>{this.props.item.body.urgency}</b>
                                </div>
                                <div className="spaceBetween border">
                                  <span>Observação</span>
                                  <b>{this.props.item.body.remittanceInformation}</b>
                                </div>
                              </span>
                            }
                            <br />
                            <div className="btnSave" onClick={this.savePDF}>
                              {this.state.translations.saveReceipt}
                            </div>
                          </div>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        )}
      </span>
    );
  }
}

export default Item;